import { render, staticRenderFns } from "./serie.html?vue&type=template&id=e7a0b8a4&"
import script from "./Serie.vue?vue&type=script&lang=js&"
export * from "./Serie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports